import styled from "styled-components";
import colors from "assets/colors";

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${(props) => (props.external ? "space-between" : "center")};
  padding: ${(props) => (props.external ? "5rem" : "0rem")} 0rem 1.5rem;
  background: ${(props) => (props.external ? "#fff" : "transparent")};

  @media (max-width: 768px) {
    padding: ${(props) => (props.external ? "2.5rem" : "0rem")} 0rem 0.5rem;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2.5rem;
  justify-items: center;
  align-content: center;
  padding: 0rem 1.5rem;
`;

export const Logo = styled.img`
  width: 100%;
  max-width: 12rem;
`;

export const Illustration = styled.img`
  width: 100%;
  max-width: 11.125rem;
`;

export const Header = styled.header`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1.5rem;

  > h1 {
    text-align: center;
    color: ${colors.black};
    font: 2.375rem/3rem "Muli Bold", sans-serif;
    margin-bottom: 0;
  }
  > h3 {
    text-align: center;
    color: ${colors.black};
    font: 1.125rem/1.438rem "Muli Bold", sans-serif;
    margin-bottom: 0;
  }
`;
